var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30.4C23.2843 30.4 30 23.6843 30 15.4C30 7.11575 23.2843 0.400024 15 0.400024C6.71573 0.400024 0 7.11575 0 15.4C0 23.6843 6.71573 30.4 15 30.4Z",
    fill: "#00A7A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6133 17.0234H15.9844V21.6523H14.0508V17.0234H9.42188V15.0898H14.0508V10.4492H15.9844V15.0898H20.6133V17.0234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddTeal);
export default __webpack_public_path__ + "static/media/Icon_Add_Teal.4523d5ba8e76df3dd09deb43c9dfd800.svg";
export { ForwardRef as ReactComponent };